import type { IAgGridCellProps } from "@/ui-modules/core/grid/cell-base-interfaces.ts";
import TableCellText from "@/ui-modules/core/grid/cells/core/TableCellText.tsx";
import { getPercentDisplayValue } from "@/ui-modules/core/grid/cells/utils.ts";

const PercentCell = (props: IAgGridCellProps) => {
  const percent: string = props.value;

  if (percent == undefined) {
    return null;
  }

  return <TableCellText {...props} style={{ textAlign: "right" }} valueFormatted={getPercentDisplayValue(percent)} />;
};

export default PercentCell;
